const ROOT = 'EDIT_RATE_ENGINE_';

const actionTypes = {
  LOAD_VERSION_REQUEST: `${ROOT}LOAD_VERSION_REQUEST`,
  LOAD_VERSION_SUCCESS: `${ROOT}LOAD_VERSION_SUCCESS`,
  LOAD_VERSION_ERROR: `${ROOT}LOAD_VERSION_ERROR`,
  CLEAR_LOADED_VERSION: `${ROOT}CLEAR_LOADED_VERSION`,

  SUBMIT_REQUEST: `${ROOT}SUBMIT_REQUEST`,
  SUBMIT_SUCCESS: `${ROOT}SUBMIT_SUCCESS`,
  SUBMIT_FAILED: `${ROOT}SUBMIT_FAILED`,

  SET_PARSED_ERRORS: `${ROOT}SET_PARSED_ERRORS`,
  CLEAR_SUBMIT_ERRORS: `${ROOT}CLEAR_SUBMIT_ERRORS`,
  CLEAR_STORE: `${ROOT}CLEAR_STORE`,
} as const;

export default actionTypes;
